import { useApiClient } from '@/composables/useApiClient'
import { getGiftStatus } from '@/utils/status-manager'

export const state = () => ({
  receiveGifts: [],
  sendGifts: [],
  giftInfo: {},
})

export const getters = {
  receiveGifts: state => state.receiveGifts,
  sendGifts: state => state.sendGifts,
  giftInfo: state => state.giftInfo,
}

export const actions = {
  resetGifts({ commit }) {
    commit('RESET_GIFTS')
  },
  getGiftItems({ commit }, query) {
    const url = `/gifts`
    return useApiClient()
      .$get(url, { params: { ...query } })
      .then(res => {
        if (res.code === 0) {
          const commitName = query.type === 'received' ? 'SET_RECEIVE_GIFTS' : 'SET_SEND_GIFTS'
          commit(commitName, res.data)
        }
        return res
      })
      .catch(error => {
        console.error('getUserOrders:error', error)
        return error
      })
  },
  async getGiftDetail({ commit }, { isVerifyAuth, giftID, query = {} }) {
    const needPub = isVerifyAuth ? '' : '/pub'
    const url = `${needPub}/gifts/${giftID}`
    const fetchGetGift = await useApiClient()
      .$get(url, { params: { ...query } })
      .then(res => {
        if (res.code === 0) {
          const giftStatus = getGiftStatus(res.data.status)
          res.data = Object.assign({ gift_status: giftStatus }, res.data)
          commit('SET_GIFT_INFO', res.data)
        }
        return res
      })
      .catch(error => {
        console.error('getGiftDetail:error', error)
        return error
      })
    return fetchGetGift
  },
  receiveGift({ commit }, { giftID, parameter = {} }) {
    const url = `/gifts/${giftID}/receive`
    return useApiClient()
      .$put(url, parameter)
      .then(res => {
        return res
      })
      .catch(error => {
        console.error('receiveGift:error', error)
        return error
      })
  },
  visibleGift({ commit }, { giftID }) {
    const url = `/gifts/${giftID}/visible`
    return useApiClient()
      .$post(url, { visible: false })
      .then(res => {
        return res
      })
      .catch(error => {
        console.error('visibleGift:error', error)
        return error
      })
  },
  getGiftArrivalTimes({ commit }, { giftID, count }) {
    return new Promise((resolve, reject) => {
      const apiUrl = `/gifts/${giftID}/arrivaltimes`
      useApiClient()
        .$get(apiUrl, { params: { count: count } })
        .then(res => {
          const responseData = res.data
          if (res.code === 329) {
            resolve(res)
          } else if (responseData === null) {
            resolve({ code: 47, message: useNuxtApp().$i18n.t('sold_out_msg') })
          }
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  bookingGiftOrder({ commit }, { giftID, bookingTime, count, email, note, remarks }) {
    const url = `/order-by-gift`
    const parameter = {
      gift_id: giftID,
      bookingtime: bookingTime,
      resource_count: count,
      member_note: note,
      email: email,
      remarks: remarks,
    }
    return useApiClient()
      .$post(url, { ...parameter })
      .then(res => {
        return res
      })
      .catch(error => {
        console.error('bookingGiftOrder:error', error)
        return error
      })
  },
}

export const mutations = {
  RESET_GIFTS(state) {
    state.receiveGifts = []
    state.sendGifts = []
  },
  SET_RECEIVE_GIFTS(state, receiveGifts) {
    state.receiveGifts = state.receiveGifts.concat(receiveGifts)
  },
  SET_SEND_GIFTS(state, sendGifts) {
    state.sendGifts = state.sendGifts.concat(sendGifts)
  },
  SET_GIFT_INFO(state, giftInfo) {
    state.giftInfo = Object.assign({}, { ...giftInfo })
  },
}
